import { call, put } from 'redux-saga/effects';
import {
  revokePatientByAgentFailure,
  revokePatientByAgentRequest,
  revokePatientByAgentSuccess,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* convertActiveToClosed(action) {
  yield put(revokePatientByAgentRequest());
  const clientId = action.payload.param.clientId;
  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/livechat-agent/closeChat/${clientId}`
    );
    if (result) {
      action.callback();
      yield put(revokePatientByAgentSuccess(result.data.data));
    } else {
      yield put(revokePatientByAgentFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(revokePatientByAgentFailure(e));
  }
}

export const revokeClientByAgent = (param, cb) => ({
  type: SagaTypes.CONVERT_ACTIVE_TO_CLOSED_CHAT,
  payload: { param },
  callback: cb,
});
